export default {
    cannot_edit_past_reservations: 'Вы не можете изменить прошлые бронирования.',
    minimum_time_difference_to_edit: 'Вы не можете изменить бронирования, запланированные менее чем за один час.',
    invalid_availability_offer: 'Услуга имеет недействительную доступность.',
    unavailable_for_rescheduling: 'Услугу нельзя перепланировать.',
    not_permissioned: 'У вас нет разрешения на редактирование этой услуги.',
    not_found: 'Услуга не найдена.',
    time_must_be_in_the_past: 'Время бронирования должно быть в прошлом.',
    mins_ahead_60:
        'Это бронирование нельзя изменить. Минимальная разница для изменения статуса должна быть как минимум за 60 минут до этого.',
    mins_ahead_20:
        'Это бронирование нельзя изменить. Минимальная разница для изменения статуса должна быть как минимум за 20 минут до этого.',
    time_zone_issue: 'Пожалуйста, проверьте время на вашем устройстве. Оно не совместимо с временем сервера.',
    minimum_5: 'Невозможно выбрать вариант меньше 5 минут',
    overlap_too_large: 'Выбрано слишком много минут. Пожалуйста, выберите меньшее количество минут.',
    unavailable_for_allowing_overlap: 'Невозможно завершить это бронирование раньше.',
}
